import React from 'react';
import { Building2, Home, Clock, CheckCircle2 } from 'lucide-react';
import { useProperties } from '../../../hooks/useProperties';
import { StatsCard } from './StatsCard';
import { PropertyChart } from './charts/PropertyChart';

interface PropertyStatsProps {
  dateRange: [Date, Date];
  selectedAgents: string[];
  selectedTypes: string[];
}

export const PropertyStats: React.FC<PropertyStatsProps> = ({
  dateRange,
  selectedAgents,
  selectedTypes,
}) => {
  const { properties } = useProperties();

  // Filtrer les propriétés selon les critères
  const filteredProperties = properties.filter(property => {
    const inDateRange = property.createdAt >= dateRange[0] && property.createdAt <= dateRange[1];
    const matchesAgent = selectedAgents.length === 0 || selectedAgents.includes(property.agent);
    const matchesType = selectedTypes.length === 0 || selectedTypes.includes(property.type);
    return inDateRange && matchesAgent && matchesType;
  });

  const forSaleCount = filteredProperties.filter(p => p.status === 'for-sale').length;
  const forRentCount = filteredProperties.filter(p => p.status === 'for-rent').length;
  const shortRentCount = filteredProperties.filter(p => p.status === 'for-short-rent').length;
  const soldCount = filteredProperties.filter(p => p.status === 'sold').length;
  const rentedCount = filteredProperties.filter(p => p.status === 'rented').length;

  return (
    <section className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
        État du portefeuille
      </h2>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <StatsCard
          title="En vente"
          value={forSaleCount}
          icon={Building2}
          trend={{
            value: '+12%',
            direction: 'up',
          }}
        />
        <StatsCard
          title="En location"
          value={forRentCount}
          icon={Home}
          trend={{
            value: '+5%',
            direction: 'up',
          }}
        />
        <StatsCard
          title="Location courte durée"
          value={shortRentCount}
          icon={Clock}
          trend={{
            value: '-2%',
            direction: 'down',
          }}
        />
        <StatsCard
          title="Vendus/Loués"
          value={soldCount + rentedCount}
          icon={CheckCircle2}
          trend={{
            value: '+8%',
            direction: 'up',
          }}
        />
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <PropertyChart properties={filteredProperties} />
      </div>
    </section>
  );
};